$(function () {
  // Init GSAP
  gsap.defaults({
    duration: 1,
    ease: "none",
  });

  // Scroll Fade effect
  const sections = gsap.utils.toArray(".scroll--fade");
  sections.forEach((section, i) => {
    var height = jQuery(section).innerHeight();

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: () => `top+=-100px bottom+=-100px`,
        end: `+=${height}px`,
        scrub: true,
        // markers: true˝
      },
    });
    tl.from(
      jQuery(section).find(".container__inner"),
      {
        y: Math.round(
          (40 / 1000) * (window.innerWidth < 1000 ? window.innerWidth : 1000)
        ),
        autoAlpha: 0,
      },
      {
        y: 0,
        stagger: 0.3,
        autoAlpha: 1,
      }
    );
  });

  var selector_open = false;
  jQuery(".selector__toggle").on("click", function (e) {
    console.log("here");
    e.preventDefault();
    if (selector_open == false) {
      selector_open = true;
      jQuery(this).parent().removeClass("closed").addClass("open");
    } else {
      selector_open = false;
      jQuery(this).parent().removeClass("open").addClass("closed");
    }
  });
  jQuery(".selector__list a").on("click", function (e) {
    e.preventDefault();
    selector_open = false;
    jQuery(this)
      .parents(".language-dropdown")
      .removeClass("open")
      .addClass("closed"); // Redirect to the language homepage
  });

  // calculateIndicatorLine();
  function convertVWtoPX(vw) {
    return vw * (document.documentElement.clientWidth / 100);
  }

  function initSwiper() {
    const swiper = new Swiper(".swiper-recipe", {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 0,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

    const swiperWine = new Swiper(".my-wines", {
      slidesPerView: 2,
      spaceBetween: 0,
      centeredSlides: true,
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 0,
          pagination: {},
          centeredSlides: false
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });
  }

  const sensesCopy = {
    mouth: {
      title: "Note de dégustation",
      description: "Le palais est gourmand, avec des tanins discrets.",
    },
    eye: {
      title: "Robe",
      description: "La robe est de couleur rouge clair, translucide.",
    },
    nose: {
      title: "Arômes",
      description: "Le nez révèle des arômes de fruits frais et d'épices.",
    },
    glass: {
      title: "Conservation",
      description: "Servir frais à 13°C",
    },
  };

  // run the currently selected effect
  function runEffect(selectedSense) {
    $("#senses__content").hide("blind", {}, 500, {});
    if (window.innerWidth < 1000) {
      $(".senses__click").hide("blind", {}, 500, {});
    }
    $(".senses__card").removeClass("selected");

    setTimeout(() => {
      // Run the effect
      $(`#${selectedSense}`).addClass("selected");
      $("#senses__content__title").text(sensesCopy[selectedSense].title);
      $("#senses__content__description").text(
        sensesCopy[selectedSense].description
      );
      $("#senses__content").show("blind", {}, 500, {});
    }, 500);
  }

  $(".senses__card").on("click", function () {
    var selectedSense = $(this).attr("id");
    runEffect(selectedSense);
  });

  $("#senses__content").hide();

  function isMobile() {
    return navigator.userAgentData?.mobile ?? false;
  }

  function animateSection(step, scrollDirection) {
    jQuery('.animation-scroll').removeClass('ended');
    if (step == 0) {
      if(scrollDirection == 'up') {
        $(".kv .container .animations__container .animation-writing").attr(
          "src",
          "//www.gerard-bertrand.com/cdn/shop/t/143/assets/kv-writing-chouchou-reverse.gif"
        );
        rewind = false;
      }      
      jQuery('.animation-bottle').removeClass('show');
      jQuery('.animation-bottle-frozen').removeClass('show');
      jQuery('.animation-slogan').removeClass('show');
      jQuery('section.kv').removeClass('show');
      
    }
    if (step == 1) {
      if(scrollDirection == 'down') {
        $(".kv .container .animations__container .animation-writing").attr(
          "src",
          "//www.gerard-bertrand.com/cdn/shop/t/143/assets/kv-writing-chouchou.gif"
        );
      }
      jQuery('.animation-writing').addClass('show');
      jQuery('.animation-bottle').removeClass('show');
      jQuery('.animation-bottle-frozen').removeClass('show');
      jQuery('.animation-slogan').removeClass('show');
      jQuery('section.kv').removeClass('show');
    }
    if (step == 2) {
      jQuery('.animation-writing').addClass('show');
      jQuery('.animation-bottle').addClass('show');
      jQuery('.animation-bottle-frozen').addClass('show');
      jQuery('.animation-slogan').removeClass('show');
      jQuery('section.kv').removeClass('show');
    }
    if (step == 3) {
      jQuery('.animation-writing').addClass('show');
      jQuery('.animation-slogan').addClass('show');
      jQuery('section.kv').addClass('show');
      jQuery('.animation-scroll').addClass('ended');
      step++;
      jQuery('body').removeClass('stop-scrolling');
    }

    if(step == 4) {
      nextSlide = true;
    }
    setTimeout(function(){
      jQuery('body').removeClass('stop-scrolling');
    },200);
  }


  // Scroll Fade effect
  const sectionsKV = gsap.utils.toArray(".kv");
  var switchWrite = false;
  var step = 0;
  sectionsKV.forEach((section, i) => {
    var height = jQuery(section).innerHeight();
    height = height * 2.5;
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        // start: () => `top+=200px bottom+=-100px`, 
        end: `+=${height}px`,
        scrub: true,
        // markers: true,
        pin: true,
        snap: 1 / (5 - 1),
        onUpdate: function(self){
          // console.log(self.direction);
          if(self.progress < 0.20) {
            if(step == 1) {
              jQuery('.wine-frozen').removeClass('show');
              jQuery('.animation-bottle').removeClass('show');
              jQuery('.animation-bottle-frozen').removeClass('show');
              jQuery('.animation-slogan').removeClass('show');
              jQuery('section.kv').removeClass('show');
              step = 0;
              $(".kv .container .animations__container .animation-writing").attr(
                "src",
                "//www.gerard-bertrand.com/cdn/shop/t/143/assets/kv-writing-chouchou-reverse.gif"
              );
            }
          }
          if(self.progress > 0.20 && self.progress < 0.40) {
            if(step == 0) {
              $(".kv .container .animations__container .animation-writing").attr(
                "src",
                "//www.gerard-bertrand.com/cdn/shop/t/143/assets/kv-writing-chouchou.gif"
              );
            }
            if(step == 0 || step == 2) {
              jQuery('.wine-frozen').removeClass('show');
              jQuery('.animation-writing').addClass('show');
              jQuery('.animation-bottle').removeClass('show');
              jQuery('.animation-bottle-frozen').removeClass('show');
              jQuery('.animation-slogan').removeClass('show');
              jQuery('section.kv').removeClass('show');
              step = 1;
            }
          }
          if(self.progress > 0.4 && self.progress < 0.6) {
            if(step == 1 || step == 3) {
              jQuery('.wine-frozen').addClass('show');
              jQuery('.animation-writing').addClass('show');
              jQuery('.animation-bottle').addClass('show');
              jQuery('.animation-bottle-frozen').addClass('show');
              jQuery('.animation-slogan').removeClass('show');
              jQuery('section.kv').removeClass('show');
              jQuery('.animation-scroll').removeClass('ended');
              step = 2;
            }
            
          }
          if(self.progress > 0.6) {
            if(step == 2) {
              jQuery('.animation-writing').addClass('show');
              jQuery('.animation-slogan').addClass('show');
              jQuery('section.kv').addClass('show');
              jQuery('.animation-scroll').addClass('ended');
              step = 3;
            }
            
          }
        },
      },
    });
  });

  const sectionsIntro = gsap.utils.toArray(".introduction");
  sectionsIntro.forEach((section, i) => {
    var height = jQuery(section).innerHeight();
    // height = height / 2;

    const tl2 = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: () => `top+=-10 bottom+=-0`,
        end: `+=100%`,
        scrub: true,
        // markers: false,
        // pin: true,
        onLeave: function(progress, direction, isActive) {
          $(".introduction .container").addClass("fixed");
          $(".introduction .accordion.first").removeClass("selected");
          $(".introduction .accordion.second").addClass("selected");

          if (window.innerWidth >= 1000) {
            $(".introduction .accordion.first .title__container").hide(
              "blind",
              {},
              500,
              {}
            );
          }
        },
        onEnterBack: function() {
          $(".introduction .container").addClass("fixed");
          $(".introduction .accordion.second").removeClass("selected");
          $(".introduction .accordion.first").addClass("selected");

          if (window.innerWidth >= 1000) {
            $(".introduction .accordion.first .title__container").show(
              "blind",
              {},
              500,
              {}
            );
          }
        },
      },
    });
  });
  

  document.addEventListener('DOMContentLoaded', function() {
    const kv = document.querySelector('.kv');
    const steps = kv.querySelectorAll('.step');
    let currentStep = 0; // Start with the first step (0-based index)

    window.addEventListener('scroll', function() {
      // Check if we're at the end of scrolling
      if (window.innerHeight + window.scrollY >= document.body.offsetHeight) {
        // Update current step based on scroll position
        updateCurrentStep();
      }
    });

    function updateCurrentStep() {
      // Loop through each step to find which one is in view
      for (let i = 0; i < steps.length; i++) {
        if (isScrolledIntoView(steps[i])) {
          currentStep = i;
          break;
        }
      }

      // Add "active" class to the current step
      steps.forEach((step, index) => {
        if (index === currentStep) {
          step.classList.add('active');
        } else {
          step.classList.remove('active');
        }
      });
    }

    function isScrolledIntoView(element) {
      const rect = element.getBoundingClientRect();
      return (
        rect.top >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
      );
    }
  });

  $(document).ready(function () {
    initSwiper();
  });
});
